// extracted by mini-css-extract-plugin
export default {"container":"IconButton_container__hyPip","container-deep":"IconButton_container-deep__cD-hi","container-light":"IconButton_container-light__a96kt"};